import { createAsyncThunk } from '@reduxjs/toolkit';
import { mastercardService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';

export const fetchMastercardSessions = createAsyncThunk(
  'mastercard/fetch-mastercard-sessions',
  (data: PaginatedRequest) => mastercardService.fetchSessions(data),
);
